import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logoAsset from "../assets/logo.jpeg";
import { MdEmail, MdLock, MdVisibility, MdVisibilityOff, MdArrowForward } from "react-icons/md";

export default function AdminLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      alert("Please enter email/mobile and password");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        "https://api2.ajpartyhouse.in/admin/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            email: email,
            password: password
          })
        }
      );

      const data = await response.json();
      console.log("Login Response:", data);

      if (data.message === "Login successful" && data.admin) {
        localStorage.setItem("admin", JSON.stringify(data.admin));
        navigate("/admin/dashboard");
      } else {
        alert(data.message || "Invalid login credentials");
      }
    } catch (error) {
      console.log("Login Error:", error);
      alert("Server error. Please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <style>{`
        .login-wrapper {
          min-height: 100vh;
          width: 100vw;
          display: flex;
          align-items: center;
          justify-content: center;
          background: radial-gradient(circle at 10% 20%, #0f172a 0%, #1e293b 90%);
          font-family: 'Inter', sans-serif;
          position: relative;
          overflow: hidden;
          padding: 20px;
        }

        /* Ambient Glow Background Orbs */
        .login-wrapper::before {
          content: '';
          position: absolute;
          width: 500px;
          height: 500px;
          background: rgba(0, 103, 177, 0.2);
          filter: blur(120px);
          border-radius: 50%;
          top: -100px;
          left: -100px;
        }

        .login-wrapper::after {
          content: '';
          position: absolute;
          width: 400px;
          height: 400px;
          background: rgba(37, 99, 235, 0.15);
          filter: blur(100px);
          border-radius: 50%;
          bottom: -50px;
          right: -50px;
        }

        .login-card-container {
          width: 100%;
          max-width: 440px;
          background: rgba(255, 255, 255, 0.96);
          backdrop-filter: blur(20px);
          border-radius: 24px;
          padding: 42px 36px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.35);
          border: 1px solid rgba(255, 255, 255, 0.3);
          z-index: 10;
        }

        .brand-header {
          text-align: center;
          margin-bottom: 32px;
        }

        .logo-wrapper {
          width: 80px;
          height: 80px;
          margin: 0 auto 16px auto;
          position: relative;
        }

        .logo-img-login {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 20px;
          box-shadow: 0 10px 25px rgba(0, 103, 177, 0.3);
          border: 3px solid #ffffff;
        }

        .brand-title {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 1.6rem;
          font-weight: 800;
          color: #0f172a;
          margin-bottom: 6px;
          letter-spacing: -0.02em;
        }

        .brand-subtitle {
          color: #64748b;
          font-size: 0.9rem;
          font-weight: 500;
        }

        .input-group-custom {
          margin-bottom: 22px;
        }

        .input-group-custom label {
          display: block;
          font-size: 0.85rem;
          font-weight: 600;
          color: #334155;
          margin-bottom: 8px;
        }

        .input-box {
          position: relative;
          display: flex;
          align-items: center;
        }

        .input-icon {
          position: absolute;
          left: 14px;
          font-size: 1.2rem;
          color: #94a3b8;
          pointer-events: none;
        }

        .input-box input {
          width: 100%;
          height: 50px;
          padding: 0 44px 0 44px;
          border: 1.5px solid #e2e8f0;
          border-radius: 12px;
          font-size: 0.92rem;
          color: #0f172a;
          background: #f8fafc;
          outline: none;
          transition: all 0.2s ease;
        }

        .input-box input:focus {
          background: #ffffff;
          border-color: #0067B1;
          box-shadow: 0 0 0 4px rgba(0, 103, 177, 0.12);
        }

        .toggle-password-btn {
          position: absolute;
          right: 14px;
          background: none;
          border: none;
          color: #64748b;
          font-size: 1.25rem;
          cursor: pointer;
          display: flex;
          align-items: center;
        }

        .toggle-password-btn:hover {
          color: #0067B1;
        }

        .submit-btn {
          width: 100%;
          height: 52px;
          background: linear-gradient(135deg, #0067B1 0%, #1e40af 100%);
          color: #ffffff;
          border: none;
          border-radius: 12px;
          font-size: 1rem;
          font-weight: 700;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin-top: 26px;
          box-shadow: 0 8px 20px rgba(0, 103, 177, 0.3);
          transition: all 0.2s ease;
        }

        .submit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 24px rgba(0, 103, 177, 0.4);
        }

        .submit-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .forgot-pass-link {
          text-align: center;
          margin-top: 20px;
          color: #0067B1;
          font-size: 0.88rem;
          font-weight: 600;
          cursor: pointer;
          transition: color 0.2s ease;
        }

        .forgot-pass-link:hover {
          text-decoration: underline;
          color: #1e40af;
        }
      `}</style>

      <div className="login-card-container">
        <div className="brand-header">
          <div className="logo-wrapper">
            <img src={logoAsset} alt="VisionTrack Logo" className="logo-img-login" />
          </div>
          <h2 className="brand-title">VisionTrack</h2>
          <p className="brand-subtitle">Optical Super Admin Portal</p>
        </div>

        <form onSubmit={handleLogin}>
          <div className="input-group-custom">
            <label>Email or Mobile Number</label>
            <div className="input-box">
              <MdEmail className="input-icon" />
              <input
                type="text"
                placeholder="admin@visiontrack.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div className="input-group-custom">
            <label>Password</label>
            <div className="input-box">
              <MdLock className="input-icon" />
              <input
                type={showPassword ? "text" : "password"}
                placeholder="••••••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="toggle-password-btn"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
              </button>
            </div>
          </div>

          <button type="submit" className="submit-btn" disabled={loading}>
            <span>{loading ? "Authenticating..." : "Sign In to Admin"}</span>
            {!loading && <MdArrowForward />}
          </button>

          <div
            className="forgot-pass-link"
            onClick={() => navigate("/forgotpassword")}
          >
            Forgot Password?
          </div>
        </form>
      </div>
    </div>
  );
}